export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553347881/DinleSevgili/images.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553285561/DinleSevgili/dinles005.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553285564/DinleSevgili/dinles002.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553285564/DinleSevgili/dinles001.jpg'
];